export default "__VITE_ASSET__032cbbaa__"